import { useEffect } from 'react';
import Cookies from 'react-cookies';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Grid, Image, Typography } from 'antd';

import { decryptDLoginBE } from 'src/utils/func/encrypt';

import classes from './index.module.less';

const HeroContainer = () => {
	const { xs } = Grid.useBreakpoint();
	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
			? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
			: isMacOs
				? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
				: isIOS
					? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
					: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
	// const imgIos = isIOS === true ? '/images/default/hero-ip.png' : '/images/default/phone-new.svg';

	useEffect(() => {
		const userData = Cookies.load('d_login') ? decryptDLoginBE(Cookies.load('d_login')) : [];
		if (userData?.uid?.length > 0) {
			window.scrollBy({
				top: 5,
				left: 0,
				behavior: 'smooth',
			});
		}
		// Cookies.remove('referal');
	}, []);

	return (
		<div className={classes.pagehero}>
			<div className={classes.headContact}>
				<h1 className={classes.title}>Hallobumil #MengertiMama</h1>
				<Typography className={classes.paragraph}>
					Bareng Hallobumil, perjalanan Mama akan lebih asyik. Dapatkan semua yang Mama butuhin,
				</Typography>
				<Typography className={classes.paragraph2}>dari tips kece sampai komunitas seru!</Typography>
				<div className={classes.store}>
					<Image
						src="/images/branda/hero/logoPlayStore.webp"
						alt="image"
						style={{
							width: xs ? 78 : 120,
							height: xs ? 27 : 40,
							cursor: 'pointer',
						}}
						preview={false}
						onClick={() => window.open(OS)}
						id="home-play-store"
					/>
					<span style={{ margin: '5px' }}></span>
					<Image
						src="/images/branda/hero/logoAppStore.webp"
						alt="image"
						style={{
							width: xs ? 78 : 120,
							height: xs ? 27 : 40,
							cursor: 'pointer',
						}}
						preview={false}
						onClick={() => window.open(OS)}
						id="home-app-store"
					/>
				</div>
				<div className={classes.phonecontent}>
					<Image
						src="/images/branda/hero/phone-new.webp"
						alt="image"
						preview={false}
						style={{
							width: xs ? 330 : 730,
							height: xs ? 291 : 509,
							marginBottom: '-100px',
							zIndex: 3,
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default HeroContainer;
